/*
  Zaktualizowano BackgroundPropertiesPanel:
  - Zmieniono pozycjonowanie z prawego dolnego rogu na lewy dolny róg (absolute left-20 bottom-4).
*/
import React, { useEffect, useState } from 'react';
import useBackgroundStore from '../store/useBackgroundStore';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiTrash2, FiMaximize2, FiEye, FiEyeOff } = FiIcons;

const BackgroundPropertiesPanel = () => {
  const { selectedBackgroundId, backgroundItem, updateBackgroundItem, removeBackgroundItem, scaleBackgroundItem } = useBackgroundStore();
  const selectedBackground = selectedBackgroundId && backgroundItem?.id === selectedBackgroundId ? backgroundItem : null;
  const [localScale, setLocalScale] = useState(1);
  const [localOpacity, setLocalOpacity] = useState(0.3);

  useEffect(() => { if (selectedBackground) { setLocalScale(selectedBackground.scale); setLocalOpacity(selectedBackground.opacity); } }, [selectedBackground]);

  if (!selectedBackground) return null;

  const handleScaleChange = (value) => { const newValue = parseFloat(value); setLocalScale(newValue); updateBackgroundItem({ scale: newValue }); };
  const scalePercent = Math.round(localScale * 100);
  const opacityPercent = Math.round(localOpacity * 100);

  return (
    <div className="absolute left-20 bottom-4 w-64 bg-white rounded-xl shadow-lg border border-gray-200 flex flex-col overflow-hidden z-10">
      <div className="bg-gray-50 px-4 py-3 border-b border-gray-200"><h3 className="font-semibold text-gray-700 text-sm">Właściwości Podkładu</h3></div>
      <div className="p-4 space-y-4 max-h-96 overflow-y-auto">
        <div className="bg-gray-50 rounded-lg p-4 flex items-center justify-center h-32 border border-gray-200"><img src={selectedBackground.imageUrl} alt="Podkład" className="max-w-full max-h-full object-contain" style={{ transform: `scale(${localScale})`, opacity: localOpacity }} /></div>
        <div className="space-y-2">
          <label className="text-sm font-medium text-gray-700">Skala ({scalePercent}%)</label>
          <div className="flex items-center gap-2">
            <button onClick={() => scaleBackgroundItem(0.9)} className="p-2 border border-gray-200 rounded-lg hover:bg-gray-50"><SafeIcon icon={FiMaximize2} className="text-sm transform scale-75" /></button>
            <input type="range" min="10" max="500" value={scalePercent} onChange={(e) => handleScaleChange(parseInt(e.target.value) / 100)} className="flex-1 h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer" />
            <button onClick={() => scaleBackgroundItem(1.1)} className="p-2 border border-gray-200 rounded-lg hover:bg-gray-50"><SafeIcon icon={FiMaximize2} className="text-sm transform scale-125" /></button>
          </div>
        </div>
        <div className="space-y-2">
          <label className="text-sm font-medium text-gray-700">Przezroczystość: {opacityPercent}%</label>
          <div className="flex items-center gap-2"><SafeIcon icon={FiEyeOff} className="text-gray-400" /><input type="range" min="0" max="100" value={opacityPercent} onChange={(e) => updateBackgroundItem({ opacity: parseInt(e.target.value) / 100 })} className="flex-1 h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer" /><SafeIcon icon={FiEye} className="text-gray-400" /></div>
        </div>
        <div className="pt-2 border-t border-gray-200">
          <button onClick={() => removeBackgroundItem()} className="w-full flex items-center justify-center gap-2 px-3 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors"><SafeIcon icon={FiTrash2} className="text-sm" />Usuń podkład</button>
        </div>
      </div>
    </div>
  );
};

export default BackgroundPropertiesPanel;